<template>
  <div class="header-container">
    <!-- 顶部图片 -->
    <div class="header-banner">
      <!-- <img src="@/assets/aogs-banner-bg.jpg" alt="ISACI Banner" class="banner-image"> -->
      <img src="@/assets/images/aogs-banner.jpg" alt="ISACI Banner" class="banner-image">
    </div>
    
    <div class="header-content">
      <ul class="nav-tabs" id="nav-conference" style="padding: 0px; margin: 0px;">
        <li >
          <router-link  to="/announcements">Announcements</router-link>
        </li>
        <!-- <li>
          <router-link to="/session-list">Session List</router-link>
        </li> -->
        <li>
          <a href="#" target="_blank">Workshop Home</a>
        </li>
        
        <li><router-link to="/registration">Workshop Registration</router-link></li>
        <!-- <li><router-link to="/member-registration">Member Registration</router-link></li> -->
        <li>
          <router-link to="/contact">Contact Us</router-link>
        </li>
      </ul>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
/* 头部样式已在common.css中定义 */

/* 头部容器 - 固定在顶部 */
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1002;
  background-color: white;
}

/* 顶部横幅图片样式 */
.header-banner {
  width: calc(100% - 260px); /* 减去侧边栏宽度 */
  height: 120px;
  overflow: hidden;
  position: relative;
  margin-bottom: 0;
  margin-left: 260px; /* 为侧边栏留出空间 */
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block; /* 确保图片正确显示 */
}

/* 确保导航栏始终显示 */
.nav-tabs {
  display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.nav-tabs li {
  display: inline-block !important;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .header-container {
    position: relative; /* 手机端不固定，可以滚动 */
  }
  
  .header-banner {
    width: 100%; /* 手机端占满全宽 */
    margin-left: 0; /* 手机端不设置左边距 */
    height: 80px; /* 手机端稍微降低高度 */
  }
  
  .banner-image {
    height: 100%;
  }
  
  /* 手机端导航栏样式调整 */
  .nav-tabs {
    flex-wrap: wrap; /* 允许换行 */
    font-size: 14px; /* 稍微减小字体 */
  }
  
  .nav-tabs li {
    margin-right: 10px; /* 减小间距 */
  }
  
  .nav-tabs li a {
    padding: 8px 10px; /* 减小内边距 */
  }
}

/* 平板端适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .header-banner {
    height: 100px; /* 平板端中等高度 */
  }
}
</style> 